export function AuthLegalFooter() {
  return (
    <p className="mt-6 max-w-[508px] text-center font-sans text-xs leading-4 text-base-400">
      By clicking Log In or Sign Up, you agree to the{" "}
      <a href="https://launch10.com/terms" className="underline">Launch10 Terms of Service</a>{" "}
      and{" "}
      <a href="https://launch10.com/privacy" className="underline">Privacy Notice</a>.
    </p>
  );
}
